const Statuses = {
  DELETED: "DELETED",
  SCR_CHECK: "SCR_CHECK",
  SCR_DONE: "SCR_DONE",
  NOT_INTERESTED: "NOT_INTERESTED",
  ACTIVE: "ACTIVE",
  DELETED_UNRESPONSIVE: "DELETED_UNRESPONSIVE",
  DELETED_CLOSED: "DELETED_CLOSED",
  NOT_INTERESTED_DELETE_RETARGET_LATER: "NOT_INTERESTED_DELETE_RETARGET_LATER",
  RVD_BY_VS: "RVD_BY_VS",
  DELETED_DUPLICATE: "DELETED_DUPLICATE",
  NOT_INTERESTED_DELETE_NEVER_RECONTACT:
    "NOT_INTERESTED_DELETE_NEVER_RECONTACT",
  EDIT: "EDIT",
  SCRAPE_FOR_CAMPAIGN: "SCRAPE_FOR_CAMPAIGN",
  CONF_NEED: "CONF_NEED",
  NOT_INTERESTED_KEEP_SPACES_ACTIVE_RETARGET_LATER:
    "NOT_INTERESTED_KEEP_SPACES_ACTIVE_RETARGET_LATER",
  CONF_MISSING: "CONF_MISSING",
  DMNOK: "DMNOK",
  FULL_IMPORT: "FULL_IMPORT",
  RDY_TO_HOST: "RDY_TO_HOST",
  NOT_FINISHED_ENTRY: "NOT_FINISHED_ENTRY",
  NOT_ACTIVE: "NOT_ACTIVE",
  HIDDEN: "HIDDEN", // sync but only searchable by Admin
};

const PaymentCapabilities = {
  OFFLINE_PAYMENT: "OFFLINE_PAYMENT",
  ONLINE_SUBSCRIPTION_PAYMENT: "ONLINE_SUBSCRIPTION_PAYMENT",
  ONLINE_COMMISSION_PAYMENT: "ONLINE_COMMISSION_PAYMENT",
};

const AccessibleStatuses = (({
  ACTIVE,
  RVD_BY_VS,
  CONF_NEED,
  CONF_MISSING,
  RDY_TO_HOST,
  NOT_FINISHED_ENTRY,
  NOT_ACTIVE,
  HIDDEN,
}) => ({
  ACTIVE,
  RVD_BY_VS,
  CONF_NEED,
  CONF_MISSING,
  RDY_TO_HOST,
  NOT_FINISHED_ENTRY,
  NOT_ACTIVE,
  HIDDEN,
}))(Statuses);

const PublishedStatuses = (({
  ACTIVE,
  RVD_BY_VS,
  HIDDEN,
  NOT_INTERESTED_KEEP_SPACES_ACTIVE_RETARGET_LATER,
}) => ({
  ACTIVE,
  RVD_BY_VS,
  HIDDEN,
  NOT_INTERESTED_KEEP_SPACES_ACTIVE_RETARGET_LATER,
}))(Statuses);

const SearchableStatuses = (({ ACTIVE, RVD_BY_VS }) => ({
  ACTIVE,
  RVD_BY_VS,
}))(Statuses);

module.exports = {
  Statuses,
  AccessibleStatuses,
  PublishedStatuses,
  SearchableStatuses,
  PaymentCapabilities,
};
